import React, {useEffect, useState} from 'react';
import {css} from '@emotion/react';

export const TabAccessibilityController = ({children}) => {
  const [outlineActive, setOutlineActive] = useState(true);

  useEffect(() => {
    const onKeyDown = ({key}) => {
      if (key === 'Tab') {
        setOutlineActive(true);
      }
    };
    const onMouseDown = () => {
      setOutlineActive(false);
    };

    document.addEventListener('keydown', onKeyDown, {
      capture: true,
      passive: true,
    });
    document.addEventListener('mousedown', onMouseDown, {
      capture: true,
      passive: true,
    });

    return () => {
      document.removeEventListener('keydown', onKeyDown, {capture: true});
      document.removeEventListener('mousedown', onMouseDown, {capture: true});
    };
  }, []);

  return (
    <span
      css={[!outlineActive
          && css`
            *:focus {
              outline: none !important;
            }
            *::-moz-focus-inner,
            *::-moz-focus-outer {
              outline: none !important;
              border: 0;
            }
          `]}
    >
      {children}
    </span>
  );
};
